import React from "react";
import PropTypes from "prop-types";

// Components
import DreamShopCollectionPageBase from "../components/Pages/DreamShopCollectionPageBase";
import PageNotFound from "../components/Pages/PageNotFound";

// Constants
import { SLEEP_GOAL_COLLECTION_DATA } from "./collectionConstants";
import { getMatchingSleepGoalCollection } from "./shop";

const getGoalCollectionPage = (url) => {
  const sleepGoalCollectionMatch = getMatchingSleepGoalCollection(
    url,
    SLEEP_GOAL_COLLECTION_DATA
  );

  if (sleepGoalCollectionMatch) {
    return {
      component: DreamShopCollectionPageBase,
      staticData: sleepGoalCollectionMatch,
    };
  }

  // No matching collection page
  return { component: PageNotFound };
};

export const DreamShopCollectionPageCompare = ({ match }) => {
  const { url } = match;
  const { component: DreamShopCollectionPage, staticData } =
    getGoalCollectionPage(url);

  return <DreamShopCollectionPage staticData={staticData} />;
};

DreamShopCollectionPageCompare.propTypes = {
  match: PropTypes.object.isRequired,
};

/**
 * Retry failed chunkfile downloads up to 4 times
 * See: https://dev.to/goenning/how-to-retry-when-react-lazy-fails-mb5
 */
export const retry = (fn, retriesLeft = 5, interval = 1000) =>
  new Promise((resolve, reject) => {
    fn()
      .then(resolve)
      .catch((error) => {
        setTimeout(() => {
          if (retriesLeft === 1) {
            reject(error);
            return;
          }

          // Passing on "reject" is the important part
          retry(fn, retriesLeft - 1, interval).then(resolve, reject);
        }, interval);
      });
  });
